import * as actionTypes from '../actionTypes/plpBanner';

export function getPLPBannerConfig() {
  return { type: actionTypes.GET_PLP_BANNER_CONFIG };
}

export function clearPLPBannerConfig() {
  return { type: actionTypes.CLEAR_PLP_BANNER_CONFIG };
}
